module.exports = __webpack_public_path__ + "img/81.7974b371.jpg";